import { z } from 'zod';

import { MaintenanceChecklistCategoryInputSchema } from './maintenance-checklist.schemas.js';

export const RegisterMaintenanceChecklistBodySchema = z.object({
  name: z.string().trim().min(1).max(255),
  categories: z.array(MaintenanceChecklistCategoryInputSchema),
});

export const RegisterMaintenanceChecklistResponseSchema = z.object({
  maintenanceChecklistId: z.uuid(),
});

export type RegisterMaintenanceChecklistBody = z.infer<
  typeof RegisterMaintenanceChecklistBodySchema
>;
export type RegisterMaintenanceChecklistResponse = z.infer<
  typeof RegisterMaintenanceChecklistResponseSchema
>;
